import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CookiesService {
  constructor() {}

  public setCookie(name: string, value: string, domain: string) {
    const cookieValue = encodeURIComponent(value) + '; domain=' + domain;
    document.cookie = name + '=' + cookieValue + '; path=/';
  }

  public getCookie(name: string): string {
    const cookieName = encodeURIComponent(name) + '=';
    const cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(cookieName) === 0) {
        return decodeURIComponent(cookie.substring(cookieName.length));
      }
    }
    return '';
  }

  public deleteCookie(name: string): void {
    document.cookie =
      encodeURIComponent(name) +
      `=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${
        environment.production ? '.stalcraft.trade' : 'localhost'
      }; path=/;`;
  }
}
